/**
 * @file: Regulation.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂规章制度管理
 */
import request from '@/utils/request'

/**
 * 食堂规章查询(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regulationGet(data) {
  return request({
    type: 'biz',
    url: 'regulation/get',
    method: 'post',
    data
  })
}

/**
 * 食堂规章新增(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regulationInsert(data) {
  return request({
    type: 'biz',
    url: 'regulation/insert',
    method: 'post',
    data
  })
}

/**
 * 食堂规章更新(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regulationUpdate(data) {
  return request({
    type: 'biz',
    url: 'regulation/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Regulation.js